import { Suspense } from "react";
import RouteIndex from "./routeIndex/RouteIndex";

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <RouteIndex />
    </Suspense>

  );
}

export default App;
